import { render, staticRenderFns } from "./stationed_product_classify.vue?vue&type=template&id=64b0072a&scoped=true"
import script from "./stationed_product_classify.vue?vue&type=script&lang=js"
export * from "./stationed_product_classify.vue?vue&type=script&lang=js"
import style0 from "./stationed_product_classify.vue?vue&type=style&index=0&id=64b0072a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b0072a",
  null
  
)

export default component.exports